import PropTypes from 'prop-types';
import { Document as PdfDocument, Page, Text, View } from '@react-pdf/renderer';

import PdfHeader from './PdfHeader';
import PdfOverviewSection from './PdfOverviewSection';
import PdfScreenSection from './PdfScreenSection';
import { styles } from './styles';

const PdfReportDocument = ({ data }) => {
  const totalFindings = data.screens.reduce((sum, s) => sum + s.findings.length, 0);

  return (
    <PdfDocument
      title={data.title}
      author="onBeacon"
      subject="Design Review Report"
    >
      {/* Summary page */}
      <Page size="A4" style={styles.page} wrap>
        <PdfHeader
          title={data.title}
          generatedAt={data.generatedAt}
          findingsCount={totalFindings}
          score={data.score}
          template={data.template}
        />

        {data.overview.reviewSnippet && (
          <PdfOverviewSection overview={data.overview} />
        )}

        {/* Page footer */}
        <View style={styles.pageFooter} fixed>
          <Text style={styles.footerText}>
            Generated by onBeacon
          </Text>
          <Text
            style={styles.footerText}
            render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
          />
        </View>
      </Page>

      {/* Per-screen pages */}
      {data.screens.map(pdfScreen => (
        <Page size="A4" style={styles.page} key={pdfScreen.pageNum} wrap>
          <PdfScreenSection pdfScreen={pdfScreen} />

          {/* Page footer */}
          <View style={styles.pageFooter} fixed>
            <Text style={styles.footerText}>
              Generated by onBeacon
            </Text>
            <Text
              style={styles.footerText}
              render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
            />
          </View>
        </Page>
      ))}

    </PdfDocument>
  );
};

PdfReportDocument.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    generatedAt: PropTypes.string.isRequired,
    score: PropTypes.number,
    template: PropTypes.string,
    overview: PropTypes.shape({
      reviewSnippet: PropTypes.string,
    }),
    screens: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      pageNum: PropTypes.number,
      totalPages: PropTypes.number,
      imageBase64: PropTypes.string,
      imageWidth: PropTypes.number,
      imageHeight: PropTypes.number,
      findings: PropTypes.arrayOf(PropTypes.shape({
        number: PropTypes.number,
        category: PropTypes.string,
        pinLocation: PropTypes.shape({
          x_percent: PropTypes.number,
          y_percent: PropTypes.number,
        }),
        label: PropTypes.string,
        detailedFeedback: PropTypes.arrayOf(PropTypes.string),
        reason: PropTypes.string,
        psychologyPrinciple: PropTypes.string,
        psychologyInsight: PropTypes.string,
        isDeeperInsight: PropTypes.bool,
        highImpactRecommendation: PropTypes.string,
        actionSteps: PropTypes.arrayOf(PropTypes.string),
      })).isRequired,
    })).isRequired,
  }).isRequired,
};

export default PdfReportDocument;
